import { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import Layout from './layout';
import LoginLayout from './layout/signIn';
import ErrorPage from './page/error';
import SignUp from './page/signup';
import SignIn from './page/signIn';
import ResetPassword from './page/signIn/resetPassword';
import Start from './page/start';
import SplashScreen from './components/splashScreen';
import PaypalApprove from './page/callback/paypalApprove';
import PaypalSubscription from './page/callback/paypalSubscription';
import Challenge from './page/main/challenge';
import Dashboard from './page/main/dashboard';
import Hub from './page/main/hub';
import MealTracker from './page/main/mealTracker';
import WorkoutTracker from './page/main/workoutTracker';

const router = createBrowserRouter([
  {
    path: '',
    errorElement: <ErrorPage />,
    Component: Layout,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'challenge',
        children: [
          {
            index: true,
            element: <Challenge />,
          },
        ],
      },
      {
        path: 'hub',
        children: [
          {
            index: true,
            element: <Hub />,
          },
        ],
      },
      {
        path: 'dashboard',
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: 'workout',
        children: [
          {
            index: true,
            element: <WorkoutTracker />,
          },
        ],
      },
      {
        path: 'meal',
        children: [{ index: true, element: <MealTracker /> }],
      },
    ],
  },
  {
    path: '',
    Component: LoginLayout,
    children: [
      {
        path: 'signin',
        element: <SignIn />,
      },
      {
        path: 'signin/reset-password',
        element: <ResetPassword />,
      },
      {
        path: 'signup',
        element: <SignUp />,
      },
      {
        path: 'start',
        element: <Start />,
      },
    ],
  },
  {
    path: 'paypal/approve',
    children: [
      {
        path: '',
        element: <PaypalApprove />,
      },
    ],
  },
  {
    path: 'success',
    children: [
      {
        path: '',
        element: <PaypalSubscription />,
      },
    ],
  },
]);

const App = () => {
  const location = typeof window !== 'undefined' && window.location;
  const [showSplash, setShowSplash] = useState(location.pathname === '/');

  return showSplash ? (
    <SplashScreen onFinish={() => setShowSplash(false)} />
  ) : (
    <RouterProvider router={router} />
  );
};

export default App;
